import { inEnum } from "@ciaopeople/cp-shatsu/TypeChecking";
import { isMediaFormatRawData, MediaFormatRawData} from "../MediaFormat.js";

/**
 * questo enumerativo continene tutti i tipi di container audio gestiti dal sistema
 */
export enum AudioContainerType  {
    MP3 = 1
};


/**
 * dati grezzi (provenienti da server) con le informazioni di formato del audio
 */
export interface AudioFormatRawData extends MediaFormatRawData {
    container: AudioContainerType,
    resourceUrl: string
};

/**
 * barrier per oggetti di tipo AudioFormatRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isAudioFormatRawData(obj: any): obj is AudioFormatRawData {
    return isMediaFormatRawData(obj) &&
        inEnum(obj['container'],AudioContainerType);
};
